export const COLOR_CONSTANTS = {
    PRIMARY_GREEN: "#6CC049",
    NEUTRAL_WHITE: "#FFFFFF",
    NEUTRAL_BLACK: "#353535",
    NEUTRAL_GRAY: "#808080",
    NEUTRAL_RED: "#CC4435",
    NEUTRAL_LIGHT_GRAY: "#F8F8F8",
    TERTIARY_SOFT: "#F4F4F4",
    TERTIARY_LIGHT_GREEN: "#EFF8ED",
    SECONDARY_BLUE: "#5EC8F2",
}